import React from "react"
import ReactDOM from "react-dom/client"
import { BrowserRouter as Router } from "react-router-dom"
import "./index.css"
import "material-icons/iconfont/material-icons.css"
import App from "./App"
// import reportWebVitals from "./reportWebVitals"
import GlobalStateProvider from "./contexts/globalStateProvider"
import type { EventMessage, AuthenticationResult } from "@azure/msal-browser"
import { PublicClientApplication, EventType } from "@azure/msal-browser"
import ThemeProvider from "./providers/ThemeProvider"
import { msalConfig } from "./constants/authConfig.constant"

import { datadogRum } from "@datadog/browser-rum"
import { reactPlugin, ErrorBoundary } from "@datadog/browser-rum-react"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

dayjs.extend(utc)

// @ts-ignore
// const buildDate = Date.now().toString()
const buildDate = new Date().toISOString()

// const versionString = dayjs(buildDate).utc().format('MMMM D, YYYY') + ' at ' + dayjs(buildDate).utc().format('h:mm A [UTC]');
const versionString = dayjs(buildDate).utc().format("MMMM D, YYYY")

console.log("versionString: ", versionString)

datadogRum.init({
  applicationId: process.env.REACT_APP_DATADOG_APPLICATION_ID!,
  clientToken: process.env.REACT_APP_DATADOG_CLIENT_TOKEN!,
  site: "us5.datadoghq.com",
  service: `collect_fe:${process.env.REACT_APP_DATADOG_NAME}`,
  env: process.env.REACT_APP_DATADOG_NAME,
  version: versionString,
  sessionSampleRate: 100, // 100% of sessions
  sessionReplaySampleRate: 0, // 0% of sessions
  trackResources: true, // Track resource loading
  trackUserInteractions: true, // Captures clicks, scrolls, etc.
  defaultPrivacyLevel: "allow", // Adjust for privacy needs
  plugins: [reactPlugin({ router: false })],
})

datadogRum.startSessionReplayRecording()

export const msalInstance = new PublicClientApplication(msalConfig)

msalInstance.initialize().then(() => {
  // Account selection logic is app dependent. Adjust as needed for different use cases.
  const accounts = msalInstance.getAllAccounts()
  if (accounts.length > 0) {
    msalInstance.setActiveAccount(accounts[0])
  }

  msalInstance.addEventCallback((event: EventMessage) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
      const payload = event.payload as AuthenticationResult
      const account = payload.account
      msalInstance.setActiveAccount(account)
    }
  })

  const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)

  const Error = () => {
    return <div>Error</div>
  }

  root.render(
    <ErrorBoundary fallback={Error}>
      <GlobalStateProvider>
        <ThemeProvider>
          <Router>
            <App pca={msalInstance} />
          </Router>
        </ThemeProvider>
      </GlobalStateProvider>
    </ErrorBoundary>,
  )
})

// Register service worker
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("Service Worker registered with scope:", registration.scope)
      })
      .catch((error) => {
        console.error("Service Worker registration failed:", error)
      })
  })
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals()
